"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var CompetitorPriceChangeReportRequest_1 = require("../model/CompetitorPriceChangeReportRequest");

var CompetitorPriceChangeReportRequestConverter_1 = require("./CompetitorPriceChangeReportRequestConverter");
/**
 * @author JMr
 */


var CompetitorPriceChangeReportRequestConverterImpl =
/*#__PURE__*/
function (_CompetitorPriceChang) {
  _inherits(CompetitorPriceChangeReportRequestConverterImpl, _CompetitorPriceChang);

  function CompetitorPriceChangeReportRequestConverterImpl() {
    _classCallCheck(this, CompetitorPriceChangeReportRequestConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(CompetitorPriceChangeReportRequestConverterImpl).call(this));
  }
  /**
   * @inheritDoc
   */


  _createClass(CompetitorPriceChangeReportRequestConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      return new CompetitorPriceChangeReportRequest_1.CompetitorPriceChangeReportRequest(CompetitorPriceChangeReportRequest_1.CompetitorPriceChangeReportRequest.schema.dateFrom.valueOf(conversions.toDate(source.dateFrom)), CompetitorPriceChangeReportRequest_1.CompetitorPriceChangeReportRequest.schema.productId.valueOf(source.productId), CompetitorPriceChangeReportRequest_1.CompetitorPriceChangeReportRequest.schema.priceZoneId.valueOf(source.priceZoneId), CompetitorPriceChangeReportRequest_1.CompetitorPriceChangeReportRequest.schema.competitorIds.valueOf(conversions.asObjectList(source, 'competitorIds', function (doc) {
        return doc;
      })));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var result = {
        dateFrom: conversions.fromDate(source.dateFrom),
        productId: source.productId,
        priceZoneId: source.priceZoneId,
        competitorIds: conversions.asObjectArray(source, 'competitorIds', function (productId) {
          return productId;
        })
      };
      return result;
    }
  }]);

  return CompetitorPriceChangeReportRequestConverterImpl;
}(CompetitorPriceChangeReportRequestConverter_1.CompetitorPriceChangeReportRequestConverter);

exports.CompetitorPriceChangeReportRequestConverterImpl = CompetitorPriceChangeReportRequestConverterImpl;